<template>
  <article :class="{ section: true }">
    <main>
      <div>
        <img
          src="/themes/sloan/img/design-spec-overview.png"
          alt="Sloan DesignSpec Overview"
        />
      </div>
      <div class="prose" v-stack-y:sm>
        <h1>{{ 'Welcome to DesignSpec' | t }}</h1>
        <p>
          {{ 'Quickly and easily build a commercial restroom spec package with any Sloan products.' | t }}
        </p>
        <ul class="prose" v-stack-y:xs>
          <li>{{ 'Add products from anywhere on the site' | t }}</li>
          <li>{{ 'Organize products into sections' | t }}</li>
          <li>{{ 'Include Spec Sheets and BIM Models in your project' | t }}</li>
          <li>{{ 'Share, print, or download your packaged DesignSpec' | t }}</li>
        </ul>
      </div>
    </main>
  </article>
</template>

<script>
import t from '../../main/i18n';

export default {
  name: 'WelcomeSection',
  filters: {
    t
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.section {
  background: white;
  border: 1px solid $color-gray-400;
  border-radius: 1.2rem;
  padding: 8px 12px;

  @media screen and (min-width: $screen-sm-min) {
    padding: 16px 24px;
  }
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 32px;

  @media screen and (min-width: $screen-md-min) {
    flex-direction: row;
  }

  & > div {
    max-width: 460px;
  }

  img {
    width: 100%;
  }

  & > div + div {
    margin-left: 36px;
  }

  h1 {
    @include text('xl', 'strong');
  }

  p {
    @include text('base');
    color: $color-gray-900;
  }

  ul {
    @include text('base');
    color: $color-gray-700;
  }
}

.prose {
  display: flex;
  flex-direction: column;
}

div.prose {
  max-width: 100%;
  margin-left: 0 !important;
  margin-top: 32px;

  @media screen and (min-width: $screen-md-min) {
    max-width: 50%;
    margin-left: 32px !important;
    margin-top: 0;
  }
}

.slo-button {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  color: $color-gray-400;
  padding: 0;
  overflow: hidden;

  .slo-icon {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 36px;
    height: 36px;
    font-size: inherit;

    svg {
      font-size: inherit;
    }

    transform: translate(-50%, -50%);
  }

  &:hover {
    color: $color-gray-700;
  }

  &:active {
    background: rgba($color-gray-400, 0.1);
    color: $color-gray-900;
  }
}
</style>
